import React from 'react';

const TeamPage = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Rev. Dr. Joseph Antony Samy. G. SJ",
      title: "The Director",
      photo: require('../../assets/img/archivist/FrAnto.jpeg'),
    },
    {
      id: 2,
      name: "A. Lobo Christy",
      title: "Archivist",
      photo: require('../../assets/img/archivist/Lobo.jpeg'),
    }
  ];

  return (
    <div className="container py-2">
      {/* Section Header */}
      <div className="text-center mb-2">
        <h2 className="fw-bold display-4">Meet Our Team</h2>
        {/*<p className="text-muted mx-auto" style={{ maxWidth: '600px' }}>
          We are a small but dedicated team of professionals focused on delivering 
          high-quality digital experiences.
        </p>*/}
      </div>

      {/* Team Grid */}
      <div className="row justify-content-center g-4">
        {teamMembers.map((member) => (
          <div key={member.id} className="col-md-5 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center p-3">
              <div className="card-body">
                <img
                  src={member.photo}
                  alt={member.name}
                  className="rounded-circle mb-4 shadow"
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                />
                <h5 className="card-title fw-bold">{member.name}</h5>
                <p className="card-text text-primary text-uppercase fw-semibold small">
                  {member.title}
                </p>
                <hr className="w-25 mx-auto my-3 text-secondary" />
                {/*<p className="text-muted small px-3">
                  Passionate about building scalable solutions and beautiful user interfaces.
                </p>*/}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamPage;